import React from 'react';
import Overlay from '../../partials/white_overlay';

const Uniforms = () => {
    return (
        <div style={{ position: 'relative' }}>
            <Overlay />
            <div className="p-4 hind" style={{ mixBlendMode: 'screen' }}>
                <h2 className="hind">Uniforms / Equipments</h2>
                <p>All players must wear jerseys/shirts during play. We ask that coaches carry a set of pennies a different color than their jersey due to the chance that the opposing team has the same uniform color. If neither team is willing to switch, it is at the discretion of the referee to play the game as is (with both team wearing the same color). Should the referee determine one of the teams needs to switch jerseys, it will be done by a coin flip. This only applies during poolplay. Once playoffs starts, the higher seed will have the option.</p>
                <p>All players must wear shin guards. Any player without shin guards will not be allowed to play. A player must not use equipment or wear anything that is dangerous to them or another player (including any kind of jewelry).</p>

                <p>All participants will need to check-in and receive a Tournament Stamp. No participant will be allowed to play without first displaying their Tournament Stamp.</p>

                <p>Teams are responsible for providing game balls. The following are the sizes for each group: U6-U8 = Size 3; U9-U12 = Size 4; and U13 & up = Size 5.</p>

                <p>CASTS: Orthopedic casts of any kind are not permitted; however, soft braces can be worn with written approval from a doctor, and judgment as to safety is at the discretion of the referee. The referee has the final say at each game for soft braces.</p>

            </div>
        </div>
    );
}

export default Uniforms;



// WEBPACK FOOTER //
// ./src/components/rules/partials/uniforms.js